<template>
  <section>
    <v-dialog
      v-model="isApprove"
      fullscreen>
      <div class="dialog-container">
        <div class="dialog-header">
          <h3>Review Identification</h3>
        </div>
        <div class="dialog-body">

          <div class="form-card">
            <div class="form-left">
              <h3 class="title-h3">{{ formData.identity == 1 ? (formData.id_type == 2 ? 'Passport' : 'HKID') : 'Business Registration Certification' }}</h3>
              <div class="upload-card">
                <!--              <img-->
                <!--                v-if="photoUrl"-->
                <!--                :src="photoUrl"-->
                <!--                alt=""/>-->
                <embed
                  v-if="isPdf"
                  :src="photoUrl"
                  width="100%"
                  height="100%"
                  type="application/pdf">
                <el-image
                  v-else
                  :src="photoUrl"
                  :preview-src-list="[photoUrl]"
                >
                </el-image>
              </div>
            </div>
            <div class="form-right">
              <div class="box">
                <div  class="table">
                  <div
                    v-if="formData.identity == 1"
                  >
                    <!--                <div class="tr">-->
                    <!--                  <span>Insurance Type</span>-->
                    <!--                  <span>{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</span>-->
                    <!--                </div>-->
                    <div class="tr">
                      <span>Title</span>
                      <span v-if="formData.isrd_title!=0">{{ formData.isrd_title_language }}</span>
                    </div>
                    <div class="tr">
                      <span>Last Name</span>
                      <span>{{ formData.isrd_lst_nm }}</span>
                    </div>
                    <div class="tr">
                      <span>First Name</span>
                      <span>{{ formData.isrd_fst_nm }}</span>
                    </div>
                    <div class="tr">
                      <span>Date of Birth</span>
                      <span>{{ formData.isrd_dob_date }}</span>
                    </div>
                    <div class="tr">
                      <span>Identify</span>
                      <span >
                        {{ formData.id_type == 2 ? 'Passport' : 'HKID' }}</span>
                    </div>
                    <template v-if="formData.id_type==2">
                      <div
                        class="tr">
                        <span>Passport</span>
                        <span>{{ formData.pp_no }}</span>
                      </div>
                      <div
                        class="tr">
                        <span>Nationality</span>
                        <span>{{ formData.id_nationality_seq_language }}</span>
                      </div>
                    </template>
                    <div
                      v-else
                      class="tr">
                      <span>HKID</span>
                      <span>{{ formData.id_no }}</span>
                    </div>

                    <div class="tr">
                      <span>Mobile No.</span>
                      <span>{{ formData.phone }}</span>
                    </div>
                    <div class="tr">
                      <span>Email</span>
                      <span>{{ formData.email }}</span>
                    </div>
                    <div class="tr">
                      <span>    Occupation and Job Nature</span>
                      <span>{{ getAllOptionName('occupation', formData.occ_id) }}</span>
                    </div>
                    <div class="tr">
                      <span>Address</span>
                      <span>{{ address }}</span>
                    </div>
                  </div>
                  <div
                    v-else
                  >
                    <div class="tr">
                      <span>Company Name</span>
                      <span>{{ formData.isrd_com_nm }}</span>
                    </div>
                    <div class="tr">
                      <span>Company Email</span>
                      <span>{{ formData.email }}</span>
                    </div>
                    <div class="tr">
                      <span>Contact Person  Name</span>
                      <span>{{ formData.contact_nm }}</span>
                    </div>
                    <!--                  <div class="tr">-->
                    <!--                    <span>Contact Person First Name</span>-->
                    <!--                    <span>{{ formData.contact_fst }}</span>-->
                    <!--                  </div>-->
                    <div class="tr">
                      <span>Contact Person Phone No.</span>
                      <span>{{ formData.contact_phone }}</span>
                    </div>
                    <div class="tr">
                      <span>Nature of Business</span>
                      <span>{{ formData.bsns_nature }}</span>
                    </div>
                    <div class="tr">
                      <span>Business Registration Number</span>
                      <span>{{ formData.id_no }}</span>
                    </div>
                    <div class="tr">
                      <span> Address</span>
                      <span>
                        {{ address }}
                      </span>
                    </div>

                  </div>
                  <!--              <div >-->
                  <div class="tr">
                    <span> Refer Code</span>
                    <span>
                      {{ formData.code }}
                    </span>
                  </div>


                  <div class="tr">
                    <span> Created By</span>
                    <span>
                      {{ formData.nick_name }}
                    </span>
                  </div>
                <!--              </div>-->
                </div>
              </div>
              <div class="dialog-footer">
                <v-button @click="isApprove = false">Cancel</v-button>
                <v-button
                  type="primary"
                  :disabled="!photoUrl"
                  @click="handlerApprove">Approve Identification
                </v-button>
              </div>
            </div>
          </div>
        </div>
      </div>



    </v-dialog>

    <send-email-sms
      ref="send-email-sms"
      :form="form"
      :initContent="detail.company_approve_url_data"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @send="handlerSend"
      @skip="handlerSkip" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {approveAccount} from '@api/account'

import SendEmailSms from '@/views/components/dialogs/send-email-sms'


export default {
  name: 'approveAccountDialog',
  components: {
    SendEmailSms
  },

  mixins: [MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    detail: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formData: {},
      isApprove: false,
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
    }
  },
  computed: {
    emailTitle(){
      return this.detail.company_approve_url_title || ''
    },
    emailListTitle(){
      return this.detail.company_approve_url_list_title || ''
    },
    address() {
      const arr = [
        this.formData.addr_room?`ROOM ${this.formData.addr_room}`:'',
        this.formData.addr_floor?`${this.formData.addr_floor}/F`:'',
        this.formData.addr_block?`BLOCK ${this.formData.addr_block}`:'',
        this.formData.addr_building,
        this.formData.addr_street,
        this.getAreaName('district', this.formData.addr_district),
        this.getAreaName('area', this.formData.addr_area),
        this.getAreaName('region', this.formData.addr_region)
      ]
      return arr.filter(item => item).join(' ')
    },
    isPdf() {
      const { id_type_pic } = this.formData
      if(id_type_pic) {
        const { client_name } = id_type_pic
        if(String(client_name).toLowerCase().indexOf('.pdf') != -1) {
          return true
        }
      }
      return false
    },
    photoUrl() {
      if (this.formData.id_type_pic)
        return this.formData.id_type_pic.url || ''
      else return ''
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    changeApproveStatus() {
      this.isApprove = !this.isApprove
    },
    handlerApprove() {
      this.$refs['send-email-sms'].changeDialog()
      // this.network().approveAccount()
    },
    handlerSend(content) {
      this.network().approveAccount(content)
    },
    handlerSkip() {
      this.network().approveAccount('', 0)
    },
    network() {
      return {
        approveAccount: async (content, skip = 1) => {
          const {data} = await approveAccount({
            user_id: this.formData.id,
            content,
            is_send: skip
          })
          this.$message({
            type: 'success',
            message: data.message
          })
          this.$parent.detailData.customer_profile.verified = 1
          this.isApprove = false
          // this.$refs['send-email-sms'].changeDialog()
          this.$emit('refresh')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">


.dialog-container {
  .dialog-header {
    padding: 15px 15px 0;
  }

  .table .tr {
    padding: 10px;
  }

  .form-card {
    display: flex;
    background: white;
    border-radius: 4px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    height: calc( 100vh - 55px);

    .form-left,
    .form-right {
      flex: 1;
    }

    .form-left {
      //padding: 20px;
      display: flex;
      //justify-content: center;
      //align-items: center;
      background: rgb(88, 96, 105);
      flex-direction: column;

      .title-h3 {
        background: #FAFBFC;
        color: #24292E;
        padding: 15px;
        font-size: 14px;
        justify-self: flex-start;
        align-self: flex-start;
        width: 100%;
        //position: absolute;
      }
    }

    .form-right {
      padding: 20px;
      border-left: 1px solid #dddfe7;
      .box{
        height: calc(100% - 30px);
      }
    }

    .form-block {
      margin-bottom: 15px;

      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        color: #616266;
        font-weight: bold;
        font-size: 14px;
      }
    }

    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }

    .form-flex {
      display: flex;
      justify-content: space-between;

      & > .form-block {
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }


  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 15px;
  }

  .upload-card {
      z-index: 0;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      margin: auto;
      width: 100%;
      // height: 100%;
      height: calc(100% - 47px);
      img {
        max-width: 100%;
        max-height: 100%;
      }
      .el-image{
        height: 100%;
      }
    }
}
</style>
